import {invokeApi} from "../bl_libs/invokeApi";
import {LOCAL_STORAGE_KEYS} from "../utils/constants";

// Teacher management — called by the school (level 22), never by the teacher
// themselves. No E2EE: these controllers return plain res.json({ data }).
//
// Adding, editing and assigning a teacher never emails them. Only
// publishTeachersService ("Publish Workspace") sends the activation email.

export const createTeacherService = (teacher_details) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/client/teacher/create',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { ...teacher_details },
    };
    return invokeApi(requestObj);
};

// { email, new_email?, first_name?, last_name?, section_codes? } — new_email is
// accepted only while the teacher's workspace is a draft (EMAIL_LOCKED after).
export const editTeacherService = (teacher_details) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/client/teacher/edit',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { ...teacher_details },
    };
    return invokeApi(requestObj);
};

// Removes the teacher from every class too ("They'll be removed from …").
export const deleteTeacherService = (email, org_code = null) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/client/teacher/delete',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { email, ...(org_code ? { org_code } : {}) },
    };
    return invokeApi(requestObj);
};

export const listTeacherService = ({ org_code = '', search = '', page = 1, limit = 10 } = {}) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const params = new URLSearchParams({
        ...(org_code ? { org_code } : {}),
        search,
        page,
        limit,
    }).toString();
    const requestObj = {
        path: `/dq_insider/dqin/client/teacher/list?${params}`,
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

/**
 * Publish Workspace — sends each selected LC Teacher their activation email.
 * Resolves to { data: { published: [emails], results: [{ email, status }] } },
 * status one of published / already_published / not_lc_teacher / not_found / failed.
 */
export const publishTeachersService = ({ org_code, emails }) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/client/teacher/publish',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { ...(org_code ? { org_code } : {}), emails },
    };
    return invokeApi(requestObj);
};
